/**
 * Brand — site logo + wordmark used in all top-bars.
 * Replaces the previous "ICT Sandbox" text + terminal icon.
 */
export default function Brand({ compact = false }) {
  return (
    <div data-testid="brand" className="flex items-center gap-2.5 font-mono">
      <img src="/brand/logo.jpeg" alt="ICT Sandbox"
        className="w-9 h-9 rounded-md object-cover border border-slate-700 shadow-md shadow-black/40"/>
      {!compact && (
        <div className="leading-tight">
          <div className="text-white font-black text-sm tracking-tight">INSTITUTIONAL <span className="text-emerald-400">SANDBOX</span></div>
          <div className="text-[9px] text-slate-500 uppercase tracking-widest">Institutional Trader</div>
        </div>
      )}
    </div>
  );
}
